exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#asseco-videochat-window{width:910px;height:500px}#asseco-videochat-window .mdl-layout__content{height:100%}@media only screen and (max-width:1024px){#asseco-videochat-window{width:600px}}@media only screen and (max-width:690px),screen and (max-height:510px){#asseco-videochat-window{width:100%!important;height:100%!important;position:fixed!important;top:0;left:0}}", ""]);

// exports
